import { SProduct } from "@/__generated__/graphql";
import { Add, Circle, MoreVert } from "@mui/icons-material";
import { Box, Card, CardContent, IconButton, Typography, useTheme } from "@mui/material";
import { memo } from "react";
type Props = { 
  colors?: SProduct["colors"];
};

function arePropsEqual<P>(prevProps: Readonly<P>, nextProps: Readonly<P>): boolean {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

function ProductCardColors({ colors }: Props) {
  if (!colors) {
    return null;
  }
  return (
    <Box
      sx={{
        position: "absolute",
        top: 8, // Adjust to fine-tune the position
        right: 8, // Adjust to fine-tune the position
        zIndex: 1, // Ensure it's on top of the image
        display: "flex",
        flexDirection: "column",
        gap: 0.7,
      }}
    >
      {colors
        .filter((a, index) => index <= 2)
        .map((a, index) => {
          return (
            <Box
              key={index}
              sx={{
                width: { xs: 12, sm: 14, md: 18 },
                height: { xs: 12, sm: 14, md: 18 },
                background: a.hex,
                borderRadius: 1000,
                border: `0.7px solid grey.400`,
                boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
              }}
            />
          );
        })}
      {colors.length > 2 && <Add sx={{ fontSize: { xs: 10, sm: 12, md: 18 } }} />}
    </Box>
  );
}

export default memo(ProductCardColors, arePropsEqual);
